import React from 'react';
import translateService from '../common/translateService';
import common from '../common/common';

import './SocialLinks.scss';

function SocialLinks() {
    const sitename = common.getSite();
    const facebookLink = (sitename) => (
        <a
            className='social-link'
            href={translateService.get(`socialLinks.${sitename}.facebook`)}
            target='_blank'
            rel='noopener'>
            <img
                className='social'
                alt={`Facebook ${sitename}`}
                title='Facebook'
                aria-label={`Facebook ${sitename}`}
                src={common.contentFromCdn({
                    path: `/Content/img/facebook-footer.svg`,
                    keepUrlAsIs: false,
                })}
            />
        </a>
    );
    const instagramLink = (sitename) => (
        <a
            className='social-link'
            href={translateService.get(`socialLinks.${sitename}.instagram`)}
            target='_blank'
            rel='noopener'>
            <img
                className='social'
                alt={`Instagram ${sitename}`}
                title='Instagram'
                aria-label={`Instagram ${sitename}`}
                src={common.contentFromCdn({
                    path: `/Content/img/instagram-footer.svg`,
                    keepUrlAsIs: false,
                })}
            />
        </a>
    );
    const stravaLink = (sitename) => (
        <a
            className='social-link'
            href={translateService.get(`socialLinks.${sitename}.strava`)}
            target='_blank'
            rel='noopener'>
            <img
                className='social'
                alt={`Strava ${sitename}`}
                title='Strava'
                aria-label={`Strava ${sitename}`}
                src={common.contentFromCdn({
                    path: `/Content/img/strava-footer.svg`,
                    keepUrlAsIs: false,
                })}
            />
        </a>
    );
    const youtubeLink = (sitename) => (
        <a
            className='social-link'
            href={translateService.get(`socialLinks.${sitename}.youtube`)}
            target='_blank'
            rel='noopener'>
            <img
                className='social'
                alt={`YouTube ${sitename}`}
                title='YouTube'
                aria-label={`YouTube ${sitename}`}
                src={common.contentFromCdn({
                    path: `/Content/img/youtube-footer.svg`,
                    keepUrlAsIs: false,
                })}
            />
        </a>
    );
    return (
        <div>
            {translateService.get(`socialLinks.${sitename}.facebook`) !==
                `socialLinks.${sitename}.facebook` && facebookLink(sitename)}
            {translateService.get(`socialLinks.${sitename}.instagram`) !==
                `socialLinks.${sitename}.instagram` && instagramLink(sitename)}
            {translateService.get(`socialLinks.${sitename}.strava`) !==
                `socialLinks.${sitename}.strava` && stravaLink(sitename)}
            {translateService.get(`socialLinks.${sitename}.youtube`) !==
                `socialLinks.${sitename}.youtube` && youtubeLink(sitename)}
        </div>
    );
}

export default SocialLinks;
